export default __webpack_public_path__ + "static/media/AneomiOpen3.43ba3cf9.jpg";